import type { LocationTreeNode } from '../api/schedulingApis';

/** Build an in-memory clone of a location subtree with fresh ids. */
export function buildCloneSubtree(
  node: LocationTreeNode,
  parentLocationId: string | null,
  isRootOfClone: boolean,
): LocationTreeNode {
  const newId = crypto.randomUUID();
  const baseName = (node.name ?? '').trim();
  const name = isRootOfClone ? (baseName ? `${baseName} copy` : 'copy') : (node.name ?? '');
  return {
    ...node,
    location_id: newId,
    name,
    parent_location_id: parentLocationId,
    location_group: Array.isArray(node.location_group) ? [...node.location_group] : [],
    meta: { ...(node.meta && typeof node.meta === 'object' ? node.meta : {}) },
    child: (node.child ?? []).map((ch) => buildCloneSubtree(ch, newId, false)),
  };
}

/** Deep snapshot of a location subtree for clipboard copy (ids and structure preserved). */
export function snapshotLocationSubtree(node: LocationTreeNode): LocationTreeNode {
  return JSON.parse(JSON.stringify(node)) as LocationTreeNode;
}
